'use strict';

exports.__esModule = true;
exports.loaders = exports.loadProfile = exports.dynamicArgumentsMap = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _widgetActions = require('../actions/widget-actions');

var _headerActions = require('../actions/header-actions');

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
	Here we specify where to find the arguments to replace in the loaders int the request.
**/
var dynamicArgumentsMap = exports.dynamicArgumentsMap = {
	_id_: 'query.profileId',
	_layoutType_: 'query.layoutType',
	_selectedTab_: 'query.selectedTab',
	_profileType_: 'query.profileType',
	_disableTabs_: 'query.disableTabs',
	_disableBanner_: 'query.disableBanner',
	_disableProfileImage_: 'query.disableProfileImage',
	_customizations: 'query.customizations'
};

var loadProfile = exports.loadProfile = function loadProfile(id, profileType) {
	var customizations = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "{}";
	var xhrConfig = arguments[3];
	return function (dispatch) {
		try {
			customizations = JSON.parse(customizations);
		} catch (e) {}

		var _ref = customizations || {},
		    minReviewRating = _ref.minReviewRating;

		minReviewRating = parseInt(minReviewRating);

		if (isNaN(minReviewRating)) {
			minReviewRating = 0;
		}

		dispatch(_widgetActions.widgetActions.setMinReviewRating(minReviewRating));

		return profileType === _constants.PRACTICE_PROFILE_TYPE && _promise2.default.all([_widgetActions.widgetActions.loadPractice(id, xhrConfig)(dispatch), _widgetActions.widgetActions.getReviews(id, { limit: 4, offset: 0, min_rating: minReviewRating }, xhrConfig)(dispatch), _widgetActions.widgetActions.getSpecialistsReviews(id, { limit: 4, offset: 0, min_rating: minReviewRating }, xhrConfig)(dispatch), _widgetActions.widgetActions.getSpecialistsReviewsCount(id, xhrConfig)(dispatch), _widgetActions.widgetActions.getSpecialistsPeerRecommendationsCount(id, xhrConfig)(dispatch), _widgetActions.widgetActions.getSpecialistsPeerRecommendations(id, { limit: 4, offset: 0 }, xhrConfig)(dispatch)]) || profileType === _constants.SPECIALIST_PROFILE_TYPE && _promise2.default.all([_widgetActions.widgetActions.loadSpecialist(id, xhrConfig)(dispatch), _widgetActions.widgetActions.getSpecialistPeerRecommendations(id, _constants.SPECIALIST_PROFILE_TYPE, {
			limit: 4,
			offset: 0
		}, xhrConfig)(dispatch), _widgetActions.widgetActions.getSpecialistReviews(id, _constants.SPECIALIST_PROFILE_TYPE, { limit: 4, offset: 0, min_rating: minReviewRating }, xhrConfig)(dispatch)]) || _promise2.default.resolve();
	};
};

var loaders = exports.loaders = [{
	key: 'widget.profileType',
	action: _widgetActions.widgetActions.setProfileType,
	arguments: ['_profileType_'],
	dynamicArguments: ['_profileType_']
}, {
	key: 'widget.layoutType',
	action: _widgetActions.widgetActions.setLayoutType,
	arguments: ['_layoutType_'],
	dynamicArguments: ['_layoutType_']

}, {
	key: 'widget.selectedTab',
	action: _headerActions.headerActions.onTabSelected,
	arguments: ['_selectedTab_'],
	dynamicArguments: ['_selectedTab_']
}, {
	key: 'widget.profile',
	action: loadProfile,
	arguments: ['_id_', '_profileType_', '_customizations'],
	dynamicArguments: ['_id_', '_profileType_', '_customizations']

}, {
	key: 'widget.disableBanner',
	action: _widgetActions.widgetActions.disableBanner,
	arguments: ['_disableBanner_'],
	dynamicArguments: ['_disableBanner_']

}, {
	key: 'widget.disableProfileImage',
	action: _widgetActions.widgetActions.disableProfileImage,
	arguments: ['_disableProfileImage_'],
	dynamicArguments: ['_disableProfileImage_']

}, {
	key: 'widget.disableTabs',
	action: _widgetActions.widgetActions.disableTabs,
	arguments: ['_disableTabs_'],
	dynamicArguments: ['_disableTabs_']

}];